import { 
  getActivoDrops, 
  createActivoDrop, 
  updateActivoDrop, 
  deleteActivoDrop,
  getActivoDropsByUser 
} from '../models/activoDropModel.js';
import { fetchUsers } from './userController.js';
import { fetchActivos } from './activoController.js';
import Swal from 'sweetalert2';
import { toasts } from 'svelte-toasts';

// Get all activo drops with pagination
export async function fetchActivoDrops(page = 1, perPage = 50) {
  try {
    const response = await getActivoDrops(page, perPage);
    return response;
  } catch (error) {
    console.error('Error fetching activo drops:', error);
    Swal.fire('Error', 'No se pudieron cargar las asignaciones de activos', 'error');
    return null;
  }
}

// Create a new activo drop assignment
export async function createActivoDropAssignment(data) {
  try {
    const response = await createActivoDrop(data);
    toasts.success('Asignación de activo creada correctamente');
    return response;
  } catch (error) {
    console.error('Error creating activo drop assignment:', error);
    Swal.fire('Error', 'No se pudo crear la asignación del activo', 'error');
    return null;
  }
}

// Update an existing activo drop assignment
export async function updateActivoDropAssignment(id, data) {
  try {
    const response = await updateActivoDrop(id, data);
    toasts.success('Asignación de activo actualizada correctamente');
    return response;
  } catch (error) {
    console.error('Error updating activo drop assignment:', error);
    Swal.fire('Error', 'No se pudo actualizar la asignación del activo', 'error');
    return null;
  }
}

// Delete an activo drop assignment
export async function removeActivoDropAssignment(id) {
  try {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "Esta acción no se puede deshacer",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      await deleteActivoDrop(id);
      toasts.success('Asignación de activo eliminada correctamente');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error removing activo drop assignment:', error);
    Swal.fire('Error', 'No se pudo eliminar la asignación del activo', 'error');
    return false;
  }
}

// Get users for dropdown selection
export async function getUsersForDropdown() {
  try {
    const response = await fetchUsers(1, 1000); // Get all users
    if (response && response.users) {
      return response.users.map(user => ({
        id: user.id,
        name: `${user.name || 'Sin nombre'} ${user.lastName || ''}`.trim() || user.email,
        email: user.email
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching users for dropdown:', error);
    return [];
  }
}

// Get activos for dropdown selection
export async function getActivosForDropdown() {
  try {
    const response = await fetchActivos(1, 1000); // Get all activos
    if (response && response.activo) {
      return response.activo.map(activo => ({
        id: activo.id,
        name: `${activo.codigo || 'N/A'} - ${activo.nombre || 'Sin nombre'}`,
        codigo: activo.codigo,
        nombre: activo.nombre
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching activos for dropdown:', error);
    return [];
  }
}

// Get activo drops by user
export async function fetchActivoDropsByUser(userId) {
  try {
    const response = await getActivoDropsByUser(userId);
    return response;
  } catch (error) {
    console.error('Error fetching activo drops by user:', error);
    return [];
  }
}
